import styled from 'styled-components';

export const CompactUnorderedList = styled.ul`
  > li {
    margin: 0;
  }
`;
